import { Affix, Button, Card, Form } from "antd";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { isMobileView } from "../../../Common/AppHelper";
import Header from "../../../Common/Header";
import ReconciliationForm from "./ReconciliationForm";

export default function CreateCartonBooking(props) {
  // Props
  const { width } = props;

  //   Router
  const propertyFormRef = useRef(null);
  const navigate = useNavigate();

  //   Form
  const [form] = Form.useForm();

  const discartForm = () => {
    navigate("/carton-booking");
  };

  const onCreated = (id) => {
    navigate(`/carton-booking/edit/${id}`);
  };

  const addReconciliation = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Add Carton & Poly Booking"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20}>
                <Button size="small" key={1} danger onClick={() => discartForm()}>
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button size="small" key={2} type="primary" onClick={() => addReconciliation()}>
                  Save
                </Button>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <ReconciliationForm ref={propertyFormRef} form={form} discartForm={discartForm} onCreated={onCreated} />
    </>
  );
}
